export default "__VITE_ASSET__CQi4l7vX__"